import React from 'react'
import { Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from 'actions/browserActions'
import { BrowserNotificationStyled } from './browserNotificationStyled'
import NotificationContent from 'components/browserNotification/notificationContent'
const BrowserNotification = () => {
  const dispatch = useDispatch()
  const { displayNotification } = useSelector((state) => ({ ...state.browser }))
  const closeNotification = () => {
    dispatch(setNotification(!displayNotification))
  }
  return (
    <BrowserNotificationStyled>
      <Alert variant="danger" onClose={closeNotification} dismissible>
        <NotificationContent />
      </Alert>
    </BrowserNotificationStyled>
  )
}

export default BrowserNotification
